import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';

import { MaterialModule } from 'src/app/material.module';
import { TicketLocationDataSource } from './services/ticket-location-data-source';
import { TicketsList } from './components/list/component';
import { TicketLocationApiService } from './services/ticket-location-api-service';
import { TicketsEdit } from './components/edit/component';
import { TicketDatePicker } from './directives/date-picker/component';
import { EventAddPriceOption } from './components/add-price-option/component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LocationPicker } from './directives/location-picker/component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [
    TicketsList,
    TicketsEdit,
    TicketDatePicker,
    EventAddPriceOption,
    LocationPicker,
  ],
  providers: [
    TicketLocationDataSource,
    TicketLocationApiService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [TicketsList],
})
export class TicketModule {}
